import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-800 text-white py-12" data-id="element-116">
      <div className="container mx-auto px-4" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-118">
          <div data-id="element-119">
            <div className="flex items-center space-x-2 mb-4" data-id="element-120">
              <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-121">
                <span className="text-white font-bold" data-id="element-122">T</span>
              </div>
              <span className="text-xl font-bold" data-id="element-123">TaxTidy</span>
            </div>
            <p className="text-gray-400" data-id="element-124">
              Dein smarter Buchhaltungsassistent für eine stressfreie
              Belegverwaltung.
            </p>
          </div>
          <div data-id="element-125">
            <h4 className="text-lg font-medium mb-4" data-id="element-126">Produkt</h4>
            <ul className="space-y-2" data-id="element-127">
              <li data-id="element-128">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-129">
                  Funktionen
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-131">
                  Preise
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-133">
                  Demo
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-135">
                  Roadmap
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-136">
            <h4 className="text-lg font-medium mb-4" data-id="element-137">Rechtliches</h4>
            <ul className="space-y-2" data-id="element-138">
              <li data-id="element-139">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-140">
                  Impressum
                </a>
              </li>
              <li data-id="element-141">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-142">
                  Datenschutz
                </a>
              </li>
              <li data-id="element-143">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-144">
                  AGB
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-145">
            <h4 className="text-lg font-medium mb-4" data-id="element-146">Kontakt</h4>
            <ul className="space-y-2" data-id="element-147">
              <li data-id="element-148">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-149">
                  Support
                </a>
              </li>
              <li data-id="element-150">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-151">
                  E-Mail
                </a>
              </li>
              <li data-id="element-152">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-153">
                  Partner werden
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-154">
          <p className="text-gray-400 mb-4 md:mb-0" data-id="element-155">
            © 2023 TaxTidy. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-4" data-id="element-156">
            <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-157">
              <span className="sr-only" data-id="element-158">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-159">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-160" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-161">
              <span className="sr-only" data-id="element-162">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-163">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.016 10.016 0 01-3.127 1.195 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" data-id="element-164" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};